module.exports = "<div [chart]=\"chart\" *ngIf=\"chartOnly\"></div>\n"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/edi/angular/app/views/transactions/transactions-type/transactions-type.component.html
// module id = ../../../../../angular/app/views/transactions/transactions-type/transactions-type.component.html
// module chunks = main